import { QueryClientProvider as QueryClientProviderTanstack } from "@tanstack/react-query";
import { type ReactNode } from "react";

import { queryClient } from "lib/query-client";

interface QueryClientProviderProps {
  children: ReactNode;
}

const QueryClientProvider: React.FC<QueryClientProviderProps> = ({ children }) => {
  return <QueryClientProviderTanstack client={queryClient}>{children}</QueryClientProviderTanstack>;
};

export default QueryClientProvider;
